<template>
  <div class="row page-heading pg_hd">
    <div class="col-12 input module_heading">
      <div class="pg_lft_menu" v-if="!embedded && !isStudentLogin">
        <b-dropdown no-caret class="navigation-menu" id="jobNavMenu">
          <template slot="button-content">
            <span id="jobNav" class="module_icon ic22-menu3x3">
              <span class="sr-only">{{ $t('jobMenu') }}</span>
            </span>
          </template>
          <div class="links new_menu">
            <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'jobHome', params: { uuid: jobUuid } }">
              <span class="lnk_txt">
                {{ $tf('home') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'jobApplicants', params: { uuid: jobUuid } }">
              <span class="lnk_txt">
                {{ $tf('applicants') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'jobViewers', params: { uuid: jobUuid } }">
              <span class="lnk_txt">
                {{ $tf('viewers') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item class="lnk_menu lnk_menu_footer" :to="{ name: 'jobReports', params: { uuid: jobUuid } }">
              <span class="lnk_txt">
                {{ $tf('reports') }}
              </span>
            </b-dropdown-item>
          </div>
        </b-dropdown>
      </div>
        <span class="ic_container">
            <span class="ic ic2_job-briefcase"></span>
        </span>

        <h1
          class="head_txt module_type_name ace_sec_hd"
          role="heading"
          aria-level="1">
            {{ jobTitle }}
        </h1>
      <div class="btn_container job-header-apply" v-if="showApply || showRecommend || isBookmarkEnabled || showEdit">
        <b-button
          v-if="showEdit"
          type="button"
          class="btn"
          @click="goToEdit">
          {{ $t('edit') }}
        </b-button>
        <b-button
          v-if="showApply && !hasApplication"
          type="button"
          class="btn"
          @click="$emit('apply')">
          {{ $t('apply') }}
        </b-button>
        <b-button
          v-if="showRecommend"
          type="button"
          class="btn"
          @click="$emit('recommend')">
          {{ $t('recommend') }}
        </b-button>
        <b-button
          v-if="isBookmarkEnabled"
          class="job-header-bookmark ace_sec_txt ic_btn bookmark_btn"
          :class="{ bookmarked: isJobBookmarked }"
          :title="isJobBookmarked ? $t('removeThisJobFromBookmark') : $t('bookmarkThisJob')"
          :aria-label="isJobBookmarked ? $t('removeThisJobFromBookmark') : $t('bookmarkThisJob')"
          role="button"
          tabindex="0"
          @click.stop="toggleJobBookmark"
          @keydown.enter.stop="toggleJobBookmark">
          <span class="ic8-bookmark3" aria-hidden="true"></span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import '../../../assets/module/css/job/jobHomepage.min.css'
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'

  export default {
    name: 'jobHeader',
    props: {
      uuid: {
        type: String,
        default: ''
      },
      embedded: {
        type: Boolean,
        default: false
      },
      showApply: {
        type: Boolean,
        default: false
      },
      showRecommend: {
        type: Boolean,
        default: false
      },
      hasApplication: {
        type: Boolean,
        default: false
      },
      appliedMessage: {
        type: String,
        default: ''
      }
    },
    mounted () {
      this.loadJob()
      this.loadAllBookmarks()
    },
    methods: {
      ...mapActions([
        'loadJobDetail',
        'loadCreateBookmarks',
        'loadDeleteBookmark',
        'loadAllBookmarks'
      ]),
      loadJob () {
        if (!this.jobUuid) {
          return
        }
        if (this.job && this.job.uuid === this.jobUuid) {
          return
        }
        this.loadJobDetail(this.jobUuid)
      },
      goToEdit () {
        if (!this.jobUuid) {
          return
        }
        this.$router.push({ name: 'jobEdit', params: { uuid: this.jobUuid } })
      },
      async toggleJobBookmark () {
        if (!this.job || !this.job.uuid) {
          return
        }
        if (this.isJobBookmarked) {
          await this.loadDeleteBookmark(this.currentBookmark.uuid)
          this.notifySuccess('Successfully deleted bookmark \'' + this.job.title + '\'')
        } else {
          const bookmark = {
            'source': 'explore',
            'entityType': 'job',
            'entityTitle': this.job.title,
            'entityUuid': this.job.uuid,
            'institutionId': this.job.employerId || this.job.employerUuid,
            'userId': localStorage.getItem('userid')
          }
          const response = await this.loadCreateBookmarks(bookmark)
          const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + this.job.title + '\''
          if (response) {
            this.notifySuccess(message)
          } else {
            this.notifyFailure(message)
          }
        }
        await this.loadAllBookmarks()
      },
      notifySuccess (text) {
        return this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        return this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    },
    computed: {
      ...mapState({
        'job': state => state.job.job,
        'bookmarks': state => state.explore.bookmarks,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'permission': state => state.user.permission
      }),
      jobUuid () {
        if (this.uuid) {
          return this.uuid
        }
        if (this.$route && this.$route.params) {
          return this.$route.params.uuid
        }
        return ''
      },
      jobTitle () {
        if (this.job && this.job.title) {
          return this.job.title
        }
        return ''
      },
      isStudentLogin () {
        return (localStorage.getItem('userrole') === 'Student')
      },
      isEmployerAdminLogin () {
        if (this.permission && this.permission.userPermission && this.permission.userPermission.employerAdminHomeView) {
          return true
        }
        let role = localStorage.getItem('userrole') || ''
        return role === 'Employer Admin' || role.toLowerCase() === 'employer admin'
      },
      showEdit () {
        return this.isEmployerAdminLogin && !this.embedded
      },
      isBookmarkEnabled () {
        let bookmarkFeature = this.enabledFeatures && this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
        return !!(bookmarkFeature && bookmarkFeature.enabled)
      },
      currentBookmark () {
        if (!this.job || !this.job.uuid || !this.bookmarks || !this.bookmarks.length) {
          return null
        }
        let found = this.bookmarks.find((bookmark) => {
          return bookmark.entityUuid === this.job.uuid
        })
        return found || null
      },
      isJobBookmarked () {
        return !!this.currentBookmark
      },
      employerName () {
        if (this.job && this.job.employer) {
          return this.job.employer
        }
        return ''
      },
      jobThumbnail () {
        if (!this.job) {
          return ''
        }
        return this.job.thumbnail || this.job.thumbnailURI || ''
      }
    },
    watch: {
      jobUuid () {
        this.loadJob()
      }
    }
  }
</script>

<style scoped>
  .page-heading.pg_hd {
    margin-bottom: 20px;
  }

  .page-heading.pg_hd .module_heading {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin-top: 0;
  }

  .page-heading.pg_hd .module_heading .head_txt {
    flex: 1 1 auto;
  }

  .page-heading.pg_hd .module_heading .job-header-apply {
    margin: 0 0 0 auto;
    padding: 0;
    float: none;
    height: 28px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    align-self: center;
  }

  .job-header-bookmark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 0;
    height: 28px;
    cursor: pointer;
    font-size: 22px;
    line-height: 28px;
    color: rgb(160, 160, 160);
  }

  .job-header-bookmark .ic8-bookmark3 {
    display: block;
    line-height: 28px;
    color: inherit;
  }

  .job-header-bookmark.bookmarked,
  .job-header-bookmark.bookmarked .ic8-bookmark3 {
    color: #F08C03;
  }

  .page-heading.pg_hd .module_heading .job-header-apply ::v-deep .btn {
    float: none;
    height: 28px;
    min-height: 28px;
    margin: 0;
    padding: 0 12px;
    line-height: 28px;
  }

  .job-header-applied {
    white-space: nowrap;
  }
  .applied {
    font-size: 28px !important;
    line-height: 1;
    margin: 0;
    display: block;
    color:green;
  }

  .job-header-employer {
    display: flex;
    align-items: center;
    flex-shrink: 1;
    min-width: 0;
    margin-left: 24px;
  }

  .job-header-logo {
    width: 28px;
    height: 28px;
    margin-right: 8px;
    border-radius: 4px;
    object-fit: cover;
    display: block;
  }

  .page-heading.pg_hd .job-header-employer .employer-name {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    color: #005f96;
    text-decoration: none;
  }

  .page-heading.pg_hd .job-header-employer .employer-name:hover,
  .page-heading.pg_hd .job-header-employer .employer-name:focus {
    color: #005f96;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/JobHeader.vue